import styled from "styled-components";

export const GreetingsContainer = styled.div`
  --white: #fff;
  max-width: 1142px;
  height: 518px;
  padding: 24px;
  margin: 0 auto;
  background-color: var(--white);

  section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
  }
`;

export const GreetingsContent = styled.div`
  --text-gray: #444444;
  --text-blue: #06719e;
  --inter: "Inter", sans-serif;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  max-width: 555px;

  h2 {
    font-family: var(--inter);
    font-weight: 700;
    font-size: 24px;
    line-height: 100%;
    color: var(--text-blue);
    margin-bottom: 0;
  }

  p {
    font-family: var(--inter);
    font-weight: 300;
    font-size: 18px;
    line-height: 100%;
    color: var(--text-gray);
    margin-bottom: 0;
    align-self: start;

    span {
      font-weight: 600;
    }
  }

  button,
  a {
    align-self: self-start;
  }
`;
